import React, { useCallback, useEffect, useState } from "react";
import { Menu, X, ArrowRight } from "lucide-react";
import { useLang } from "../../i18n";

const LangToggle = () => {
  const { lang, setLang } = useLang();
  return (
    <div className="flex items-center rounded-full border border-[var(--border)] bg-white p-0.5 text-[11px] font-semibold" data-testid="language-toggle">
      {["de", "en"].map((l) => (
        <button key={l} onClick={() => setLang(l)} data-testid={`language-toggle-${l}`}
          className={`rounded-full px-2.5 py-1 transition-colors ${lang === l ? "bg-[var(--ink)] text-white" : "text-slate-400 hover:text-[var(--ink)]"}`}>{l.toUpperCase()}</button>
      ))}
    </div>
  );
};

export const Header = () => {
  const { t } = useLang();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const onScroll = useCallback(() => setScrolled(window.scrollY > 8), []);
  useEffect(() => {
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [onScroll]);
  const links = [
    { href: "#tenders", label: t.nav.tenders, id: "nav-tenders" },
    { href: "#partners", label: t.nav.partners, id: "nav-partners" },
    { href: "#workspace", label: t.nav.workspace, id: "nav-workspace" },
  ];
  return (
    <header className={`fixed inset-x-0 top-0 z-50 transition-colors ${scrolled ? "border-b border-[var(--border)] bg-white/85 backdrop-blur" : "bg-transparent"}`}>
      <div className="mx-auto flex max-w-[1180px] items-center justify-between px-4 py-3.5 sm:px-6 lg:px-8">
        <a href="#top" data-testid="header-wordmark" className="flex items-center gap-2">
          <span className="font-heading text-[20px] font-extrabold text-[var(--ink)]">Procur<span className="text-[var(--blue)]">mo</span></span>
        </a>
        <nav className="hidden items-center gap-1 md:flex">
          {links.map((l) => (<a key={l.href} href={l.href} data-testid={l.id} className="rounded-lg px-3 py-2 text-sm font-medium text-slate-500 transition-colors hover:text-[var(--ink)]">{l.label}</a>))}
        </nav>
        <div className="hidden items-center gap-3 md:flex">
          <LangToggle />
          <a href="#early-access" data-testid="header-primary-cta-button" className="group inline-flex items-center gap-1.5 rounded-full bg-[var(--blue)] px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-[var(--blue-2)]">{t.cta.primary}<ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" strokeWidth={2} /></a>
        </div>
        <div className="flex items-center gap-2 md:hidden">
          <LangToggle />
          <button onClick={() => setOpen((o) => !o)} className="grid h-9 w-9 place-items-center rounded-lg border border-[var(--border)] bg-white" aria-label="Menu" data-testid="mobile-menu-button">{open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}</button>
        </div>
      </div>
      {open && (
        <div className="border-t border-[var(--border)] bg-white md:hidden">
          <div className="mx-auto max-w-[1180px] px-4 py-3 sm:px-6">
            {links.map((l) => (<a key={l.href} href={l.href} onClick={() => setOpen(false)} className="block rounded-lg px-3 py-2.5 text-sm font-medium text-slate-600">{l.label}</a>))}
            <a href="#early-access" onClick={() => setOpen(false)} className="mt-2 block rounded-full bg-[var(--blue)] px-4 py-2.5 text-center text-sm font-semibold text-white">{t.cta.primary}</a>
          </div>
        </div>
      )}
    </header>
  );
};
